'use strict';
(function () {
  var API_BASE = 'https://api-cdn.yotpo.com/v3/storefront/store/';
  var MAX_PER_PAGE = 150;
  var SVG_NS = 'http://www.w3.org/2000/svg';
  function sortParams(sort) {
    if (sort === 'high') return { sort: 'rating', direction: 'desc' };
    if (sort === 'low') return { sort: 'rating', direction: 'asc' };
    return { sort: 'date', direction: 'desc' };
  }
  function formatDate(iso) {
    var date = new Date(iso);
    return isNaN(date.getTime()) ? '' : date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
  }
  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }
  function verifiedBadge() {
    var badge = el('span', 'cc-rv__verified');
    var svg = document.createElementNS(SVG_NS, 'svg');
    var attrs = { width: '12', height: '12', viewBox: '0 0 24 24', fill: 'none', stroke: '#171717', 'stroke-width': '3.2', 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'aria-hidden': 'true' };
    Object.keys(attrs).forEach(function (key) { svg.setAttribute(key, attrs[key]); });
    var path = document.createElementNS(SVG_NS, 'path');
    path.setAttribute('d', 'M20 6L9 17l-5-5');
    svg.appendChild(path);
    badge.appendChild(svg);
    badge.appendChild(document.createTextNode(' Verified buyer'));
    return badge;
  }
  function initReviews(root) {
    if (root.dataset.ccInit === 'on') return;
    root.dataset.ccInit = 'on';
    var appKey = root.getAttribute('data-app-key');
    var productId = root.getAttribute('data-product-id');
    var perPage = parseInt(root.getAttribute('data-per-page'), 10) || 5;
    var yotpoWrap = document.getElementById(root.getAttribute('data-details-id'));
    var writeBtn = yotpoWrap ? yotpoWrap.querySelector('[data-cc-write]') : null;
    function expandYotpo() {
      if (!yotpoWrap) return;
      yotpoWrap.classList.remove('cc-rv__yotpo--collapsed');
    }
    if (writeBtn) {
      writeBtn.addEventListener('click', function () {
        var yotpoBtn = yotpoWrap.querySelector('#yotpo-main-widget-btn, .yotpo-new-review-btn');
        // Collapsed widget: Yotpo's button is in the DOM but clipped; a programmatic click still opens its dialog.
        if (yotpoBtn) { yotpoBtn.click(); return; }
        expandYotpo();
        var app = yotpoWrap.querySelector('[data-cc-app]');
        if (app && app.scrollIntoView) app.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
    var q = function (sel) { return root.querySelector(sel); };
    var avgEl = q('[data-cc-avg]'), avgLabelEl = q('[data-cc-avg-label]'), starsFillEl = q('.cc-rv__stars-fill'), countEl = q('[data-cc-count]');
    var bars = Array.prototype.slice.call(root.querySelectorAll('[data-cc-bar]'));
    var showingEl = q('[data-cc-showing]'), clearBtn = q('[data-cc-clear]'), sortSelect = q('[data-cc-sort]');
    var itemsEl = q('[data-cc-items]'), emptyEl = q('[data-cc-empty]'), moreBtn = q('[data-cc-more]');
    var defaultSort = root.getAttribute('data-default-sort') === 'recent' ? 'recent' : 'high';
    var state = { star: 0, sort: defaultSort, page: 1, shown: 0, pool: [], filteredTotal: 0, controller: null };
    function fallback() { root.classList.add('cc-rv--fallback'); expandYotpo(); }
    if (!appKey || !productId) { fallback(); return; }
    function buildUrl(params) {
      var query = Object.keys(params).map(function (key) { return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]); });
      return API_BASE + encodeURIComponent(appKey) + '/product/' + encodeURIComponent(productId) + '/reviews?' + query.join('&');
    }
    // request() centralizes fetch + abort-in-flight + error handling; onData receives the
    // parsed JSON, onError defaults to the full fallback (used only for the very first load —
    // a failed "show more" leaves the already-rendered list alone).
    function request(params, onData, onError) {
      if (state.controller) state.controller.abort();
      state.controller = new AbortController();
      fetch(buildUrl(params), { signal: state.controller.signal }).then(function (res) {
        if (!res.ok) throw new Error('yotpo fetch failed');
        return res.json();
      }).then(onData).catch(function (err) {
        if (err && err.name === 'AbortError') return;
        (onError || fallback)();
      });
    }
    function setBars(distribution, total) {
      bars.forEach(function (btn) {
        var n = btn.getAttribute('data-cc-bar');
        var count = (distribution && distribution[n]) || 0;
        var pct = total > 0 ? (count / total * 100) : 0;
        btn.querySelector('[data-cc-bar-fill]').style.width = pct.toFixed(1) + '%';
        btn.querySelector('[data-cc-bar-count]').textContent = String(count);
        btn.setAttribute('aria-label', count + ' of ' + plural(total, 'review') + (count === 1 ? ' is ' : ' are ') + n + (n === '1' ? ' star' : ' stars') + '. Filter to ' + n + '-star reviews.');
        btn.disabled = false;
      });
      if (sortSelect) sortSelect.disabled = false;
    }
    function plural(n, word) {
      return n + ' ' + (n === 1 ? word : word + 's');
    }
    function setSummary(bottomline) {
      var avg = bottomline.averageScore || 0;
      var total = bottomline.totalReview || 0;
      if (avgEl) avgEl.textContent = avg.toFixed(1);
      if (countEl) countEl.textContent = plural(total, 'review');
      if (starsFillEl) starsFillEl.style.width = (avg / 5 * 100).toFixed(1) + '%';
      if (avgLabelEl) avgLabelEl.textContent = 'Average rating ' + avg.toFixed(1) + ' out of 5, based on ' + plural(total, 'review') + '.';
      setBars(bottomline.starDistribution, total);
    }
    function renderItems(reviews, append) {
      if (!append) itemsEl.textContent = '';
      reviews.forEach(function (review) {
        var article = el('article', 'cc-rv__item');
        var head = el('div', 'cc-rv__item-head');
        var starsWrap = el('p', 'cc-rv__item-stars');
        starsWrap.setAttribute('aria-label', 'Rated ' + review.score + ' out of 5');
        var starsFill = el('span', 'cc-rv__item-stars-fill', '★★★★★');
        starsFill.setAttribute('aria-hidden', 'true');
        starsFill.style.width = (review.score / 5 * 100) + '%';
        starsWrap.appendChild(document.createTextNode('★★★★★'));
        starsWrap.appendChild(starsFill);
        head.appendChild(starsWrap);
        if (review.verifiedBuyer) head.appendChild(verifiedBadge());
        article.appendChild(head);
        if (review.title) article.appendChild(el('h3', 'cc-rv__item-title', review.title));
        if (review.content) article.appendChild(el('p', 'cc-rv__item-body', review.content));
        var name = (review.user && review.user.displayName) || 'Anonymous';
        var date = formatDate(review.createdAt);
        article.appendChild(el('p', 'cc-rv__item-meta', date ? name + ' · ' + date : name));
        itemsEl.appendChild(article);
      });
    }
    // starDistribution's count can exceed the one 150-review window this script fetched
    // (state.pool); cap to what was actually fetched so "Show more" never stalls.
    function cappedTotal() {
      return Math.min(state.filteredTotal, state.pool.length);
    }
    function updateShowing(shown, total) {
      if (!showingEl) return;
      if (total === 0) { showingEl.textContent = state.star ? 'No reviews at this rating.' : 'No reviews yet.'; return; }
      showingEl.textContent = state.star
        ? 'Showing ' + shown + ' of ' + total + ' · ' + state.star + (String(state.star) === '1' ? ' star' : ' stars')
        : 'Showing ' + shown + ' of ' + plural(total, 'review');
    }
    function updateEmptyAndMore(shown, total) {
      if (emptyEl) emptyEl.hidden = total !== 0;
      if (moreBtn) { moreBtn.hidden = shown >= total; moreBtn.disabled = shown >= total; }
      if (clearBtn) clearBtn.hidden = !state.star;
    }
    // The storefront CDN endpoint's documented "star" filter param is not honoured
    // server-side (verified empirically). bottomline.starDistribution is accurate
    // regardless, so it drives the bars/count either way; to filter the list itself we
    // fetch one page at the API's max perPage (150) and filter client-side by score.
    function loadInitial() {
      if (state.star) {
        request(Object.assign({ page: 1, perPage: MAX_PER_PAGE, star: state.star }, sortParams(state.sort)), function (data) {
          setSummary(data.bottomline);
          var matching = (data.reviews || []).filter(function (r) { return r.score === state.star; });
          state.pool = matching;
          state.filteredTotal = (data.bottomline.starDistribution && data.bottomline.starDistribution[state.star]) || matching.length;
          state.shown = Math.min(perPage, matching.length);
          renderItems(matching.slice(0, state.shown), false);
          updateShowing(state.shown, cappedTotal());
          updateEmptyAndMore(state.shown, cappedTotal());
        });
        return;
      }
      request(Object.assign({ page: 1, perPage: perPage }, sortParams(state.sort)), function (data) {
        setSummary(data.bottomline);
        state.shown = (data.reviews || []).length;
        state.page = 1;
        renderItems(data.reviews || [], false);
        updateShowing(state.shown, data.pagination.total);
        updateEmptyAndMore(state.shown, data.pagination.total);
      });
    }
    function loadMore() {
      if (state.star) {
        var next = Math.min(state.shown + perPage, state.pool.length);
        renderItems(state.pool.slice(state.shown, next), true);
        state.shown = next;
        updateShowing(state.shown, cappedTotal());
        updateEmptyAndMore(state.shown, cappedTotal());
        return;
      }
      request(Object.assign({ page: state.page + 1, perPage: perPage }, sortParams(state.sort)), function (data) {
        var reviews = data.reviews || [];
        setSummary(data.bottomline);
        state.shown += reviews.length;
        state.page += 1;
        renderItems(reviews, true);
        updateShowing(state.shown, data.pagination.total);
        updateEmptyAndMore(state.shown, data.pagination.total);
      }, function () {});
    }
    if (moreBtn) moreBtn.addEventListener('click', loadMore);
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        state.star = 0;
        bars.forEach(function (btn) { btn.setAttribute('aria-pressed', 'false'); });
        loadInitial();
      });
    }
    bars.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var n = parseInt(btn.getAttribute('data-cc-bar'), 10);
        state.star = state.star === n ? 0 : n;
        bars.forEach(function (other) { other.setAttribute('aria-pressed', other === btn && state.star ? 'true' : 'false'); });
        loadInitial();
      });
    });
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        state.sort = sortSelect.value;
        loadInitial();
      });
    }
    loadInitial();
  }
  document.querySelectorAll('[data-cc-reviews]').forEach(initReviews);
})();
